const networks = [
  "FOX", "ABC", "NBC", "CBS", "ESPN", "CNN",
  "Fox News", "MSNBC", "Discovery", "HGTV",
  "Food Network", "Bravo", "AMC", "TBS", "TNT",
  "Lifetime", "A&E", "History", "Paramount", "Peacock"
];

export function LogoCarousel() {
  return (
    <div className="w-full overflow-hidden py-8 border-t border-white/10">
      <p className="text-center text-white/75 text-xs uppercase tracking-widest mb-6">
        Advertise on Premium Networks
      </p>
      <div className="relative">
        {/* Gradient masks */}
        <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-navy-deep to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-navy-deep to-transparent z-10" />
        
        {/* Scrolling track */}
        <div className="flex logo-carousel">
          {/* First set */}
          {networks.map((network, idx) => (
            <div
              key={`a-${idx}`}
              className="flex-shrink-0 px-6 md:px-8"
            >
              <span className="text-white/80 hover:text-white transition-colors duration-300 text-sm md:text-base font-medium whitespace-nowrap">
                {network}
              </span>
            </div>
          ))}
          {/* Duplicate set for seamless loop */}
          {networks.map((network, idx) => (
            <div
              key={`b-${idx}`}
              className="flex-shrink-0 px-6 md:px-8"
            >
              <span className="text-white/80 hover:text-white transition-colors duration-300 text-sm md:text-base font-medium whitespace-nowrap">
                {network}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
